import React from "react";
import { useTranslation } from "react-i18next";
import { useRemoveCostProfile } from "@planzone/view-models";
import { Modal } from "@common/modal";
import { Button } from "@common/button";
import { useAllocationUnit } from "@common/allocationUnit";
import { Props } from "./types";
import styles from "./styles.scss";

function CostProfileRemoval({ costProfile, cancel }: Props) {
  const { t } = useTranslation();
  const { isRequestPending, removeCostProfile } =
    useRemoveCostProfile(costProfile);
  const symbol = useAllocationUnit({});

  return (
    <Modal
      header={t("removeCostProfile.title")}
      headerClassName={styles.header}
      close={cancel}
    >
      <div className={styles.main}>
        <div className={styles.group}>
          <p className={styles.text}>
            {t("removeCostProfile.message", {
              name:
                typeof costProfile.cost !== "undefined"
                  ? `${costProfile.name} ${costProfile.name} / ${symbol}`
                  : costProfile.name,
            })}
          </p>
        </div>
        <div className={styles.buttons}>
          <Button type="cancel" press={cancel}>
            {t("removeCostProfile.cancel")}
          </Button>
          <Button
            type="delete"
            status={isRequestPending ? "pending" : "none"}
            press={() => removeCostProfile(costProfile)}
          >
            {t("removeCostProfile.confirm")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export { CostProfileRemoval };
